import styled from 'styled-components';
import {
    space,
    layout,
    typography,
    color,
    border,
    position,
    SpaceProps,
    LayoutProps,
    TypographyProps,
    ColorProps,
    BorderProps,
    PositionProps,
} from 'styled-system';

type Props = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export const StyledTH = styled.th<Props>`
    padding: ${({ theme }) => theme.space[5]} ${({ theme }) => theme.space[4]};
    font-weight: ${({ theme }) => theme.fontWeights.medium};

    ${space}
    ${layout}
  ${typography}
  ${color}
  ${border}
  ${position}
`;
